import * as moment from 'moment';
import {Dictionary} from './dictionary.model';
import {TravelServices} from './travelServices.model';
import {FileItem} from './file.model';

export class Travel {
  id: number;
  dateFrom: any;
  dateTo: any;
  createdAt: any;
  deadline: any;
  packageName: string;
  comment: string;
  cost: number;
  status: Dictionary;
  paymentStatus: string;
  client: {
    id: number,
    first_name: string,
    last_name: string,
    name: string,
    text: string,
    phone: string,
  };
  locations: {
    id: number,
    text: string,
    services: TravelServices[]
  }[];
  locationNames: string;
  serviceNames: string;
  currency: string;
  manager: {
    id: number,
    firstName: string,
    lastName: string,
    name: string,
    text: string
  };
  contacts: any[];
  invoices: any[];
  invoice: {
    id: number,
    name: string
  };
  paymentMethod: {
    id: number;
    name: string;
  };
  // primaryContact: Contact;
  files: FileItem[];
  folders: any;
  passengers: any[];
  isPassedDate: boolean;
  totalCost: { usd: number, eur: number, uah: number };
  exchangeRate: { usd: number, isUsdRateUsed: boolean, eur: number, isEurRateUsed: boolean, eurUSD: number, usdEur: number };
  image: string;
  schedule: any[];
  upcomingSchedule: any[];
  bankExpenses: number;
  serviceFee: number;
  bankExpensesCurrency: number;
  serviceFeeCurrency: number;
  showPrice: boolean;

  setFromApiModel(apiModel: any): this {
    this.showPrice = apiModel.show_price;
    this.bankExpenses = apiModel.bank_expenses_amount ? apiModel.bank_expenses_amount : 0;
    this.bankExpensesCurrency = apiModel.bank_expenses_currency;
    this.serviceFee = apiModel.service_fee ? apiModel.service_fee : 0;
    this.serviceFeeCurrency = apiModel.service_fee_currency;
    this.totalCost = {usd: 0, eur: 0, uah: 0};
    this.exchangeRate = {usd: 0, eur: 0, isUsdRateUsed: false, isEurRateUsed: false, eurUSD: 0, usdEur: 0};
    this.id = apiModel.id;
    this.packageName = apiModel.package_name;
    this.dateFrom = moment(apiModel.date_from);
    this.dateTo = moment(apiModel.date_to);
    this.createdAt = Number(moment(apiModel.created_at).format('x'));
    this.deadline = apiModel.deadline ? moment(apiModel.deadline) : null;
    this.currency = apiModel.currency;
    this.comment = apiModel.comment;
    this.paymentMethod = apiModel.payment_method;
    this.cost = apiModel.cost;
    this.status = new Dictionary().setFromApiModel(apiModel.status);
    this.paymentStatus = [1, 2, 3].indexOf(apiModel.status.id) ? 'Ожидает подтверждения' :
      apiModel.status.id == 4 ? 'Подтверждено'
        : 'Другой статус'

    this.client = {
      id: apiModel.client.id,
      first_name: apiModel.client.first_name,
      last_name: apiModel.client.last_name,
      name: `${apiModel.client.first_name} ${apiModel.client.last_name}`,
      text: `${apiModel.client.first_name} ${apiModel.client.last_name}`,
      phone: `${apiModel.client.phone}`
    };
    if (apiModel.invoices) {
      this.invoices = apiModel.invoices;
    }
    if (apiModel.invoice) {
      this.invoice = apiModel.invoice;
    }

    const locationNames = [];
    const serviceNames = [];
    this.locations = apiModel.locations.map(location => {
      if (location.name !== "Все локации") {
        locationNames.push(location.name);
      }
      return {
        id: location.id,
        name: location.name,
        services: location.services ? location.services.map(i => {
          serviceNames.push(i.name);
          return new TravelServices().setFromApiModel(i);
        }) : []
      };
    });

    this.locationNames = locationNames.join(', ');
    this.serviceNames = serviceNames.filter((value, index, self) => {
      return self.indexOf(value) === index;
    }).join(', ');
    this.manager = {
      id: apiModel.manager.id,
      firstName: apiModel.manager.first_name,
      lastName: apiModel.manager.last_name,
      name: `${apiModel.manager.first_name} ${apiModel.manager.last_name}`,
      text: `${apiModel.manager.first_name} ${apiModel.manager.last_name}`
    };

    this.files = [];
    this.folders = [];
    if (apiModel.folders && apiModel.folders.length) {
      apiModel.folders.forEach((folder) => {
        let f = {
          id: folder.id,
          name: folder.name,
          files: [],
        }

        if (folder.documents.length) {
          folder.documents.forEach(item => {
            f.files.push(new FileItem().setFromApiModel(item));
          });
        }
        this.folders.push(f);
      });
    }


    this.files = [];
    if (apiModel.documents && apiModel.documents.length) {
      apiModel.documents.forEach((item) => {
        this.files.push(new FileItem().setFromApiModel(item));
      });
    }
    this.files = this.files.reverse();

    this.passengers = [];
    if (apiModel.passengers && apiModel.passengers.length) {
      apiModel.passengers.forEach((item) => {
        this.passengers.push({
          id: item.id,
          clientId: item.client.id,
          firstName: item.client.first_name,
          secondName: item.client.second_name,
          lastName: item.client.last_name,
          name: `${item.client.first_name} ${item.client.second_name} ${item.client.last_name}`,
          birthday: item.client.birthday ? moment(item.client.birthday) : null,
          category: item.client.age_category,
          isClient: !!item.client.is_client,
          isMember: !!item.is_family,
          isNew: !!item.is_new,
          documents: item.documents && item.documents.length ? item.documents : []
        });
      });
    }
    this.isPassedDate = apiModel.deadline ? (moment().format('X000') > moment(apiModel.deadline).format('X000')) : false;
    this.image = apiModel.image ? apiModel.image : '';

    this.schedule = [];
    if (apiModel.schedule && apiModel.schedule.length > 0) {
      apiModel.schedule.map(line => {
        this.schedule.push({
          location: line.location,
          date: line.date,
          time: line.time ? line.time : null,
          serviceTypeId: line.serviceTypeId,
          serviceName: line.serviceName,
          comment: line.comment,
          roomType: line.roomType ? line.roomType : null,
          tenants: line.tenants ? line.tenants : null,
          roomCount: line.roomCount ? line.roomCount : null,
          flightFrom: line.flight_from ? line.flight_from : null,
          flightTo: line.flight_to ? line.flight_to : null,

          displayedDate: `${line.date} ${line.time ? line.time : ''}`,
          displayedName: line.serviceTypeId === 2 ? `Перелет: ${line.flight_from} - ${line.flight_to}` : `${line.service.name}, ${line.service.description}`,
          displayedComment: line.serviceTypeId === 1 ? [`Тип номера: ${line.roomType}  Количество: ${line.roomCount}`,
            `Жильцы: ${line.tenants}`,
            `Комментарий: ${line.comment}`] : [line.comment]
        });
      });
      this.upcomingSchedule = this.schedule.filter(item => moment(item.date, 'YYYY-MM-DD').isSameOrAfter(moment(), 'day'));
    }
    return this;

  }
}

